var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var Svg24 = function Svg24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 25 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M9.25 16c1.306 0 2.414.835 2.826 2h9.174a1 1 0 1 1 0 2h-9.174a2.998 2.998 0 0 1-5.652 0H3.25a1 1 0 1 1 0-2h3.174c.412-1.165 1.52-2 2.826-2m0 2a1 1 0 1 0 0 2 1 1 0 0 0 0-2M15.25 9c1.306 0 2.414.835 2.826 2h3.174a1 1 0 1 1 0 2h-3.174a2.998 2.998 0 0 1-5.652 0H3.25a1 1 0 1 1 0-2h9.174c.412-1.165 1.52-2 2.826-2m0 2a1 1 0 1 0 0 2 1 1 0 0 0 0-2M8.25 2c1.306 0 2.414.835 2.826 2H21.25a1 1 0 1 1 0 2H11.076A3 3 0 0 1 8.25 8a3 3 0 0 1-2.826-2H3.25a1 1 0 0 1 0-2h2.174c.412-1.165 1.52-2 2.826-2m0 2a1 1 0 1 0 0 2 1 1 0 0 0 0-2",
    clipRule: "evenodd"
  })));
};
export default Svg24;